import {Record} from 'immutable';

import * as ManagePlanActions from 'web-app/react/plans/manage-plan/actions';
import * as PlanConstants from 'web-app/react/entities/plans/constants';
import {match, makeReducer} from 'web-app/util/redux';

import * as Actions from './actions';

interface IChoosePublicFunding {
    show: boolean;
    hasFetchedPreview: boolean;
    isFetching: boolean;
    planPublicFundingBehaviors: any;
    fundingMethod: PlanConstants.PUBLIC_FUNDING_TYPE;
    institutionId: string;
    defaultMaxFundedMinutesPerDay: number | null;
}

export class ChoosePublicFunding extends Record<IChoosePublicFunding>({
    show: false,
    hasFetchedPreview: false,
    isFetching: false,
    planPublicFundingBehaviors: null,
    fundingMethod: PlanConstants.PUBLIC_FUNDING_TYPE.UNKNOWN,
    institutionId: '',
    defaultMaxFundedMinutesPerDay: null,
}) {}

export default makeReducer<ChoosePublicFunding>(
    [
        match(Actions.show, (state, {payload}) => {
            return new ChoosePublicFunding({
                show: true,
                fundingMethod: payload.fundingMethod,
                institutionId: payload.institutionId,
                defaultMaxFundedMinutesPerDay: payload.defaultMaxFundedMinutesPerDay,
            });
        }),
        match(Actions.changeFundingMethod, (state, {payload}) => {
            return state.merge({
                fundingMethod: payload.newFundingMethod,
            });
        }),
        match(ManagePlanActions.previewPlanPublicFundingSuccess, (state, {payload}) =>
            state.merge({
                isFetching: false,
                hasFetchedPreview: true,
                planPublicFundingBehaviors: payload.plan.behaviors,
            }),
        ),
        match(ManagePlanActions.previewPlanPublicFundingFailed, state =>
            state.merge({
                isFetching: false,
            }),
        ),
        match(Actions.save, () => new ChoosePublicFunding()),
        match(Actions.hide, () => new ChoosePublicFunding()),
        match(Actions.manuallyClose, () => new ChoosePublicFunding()),
    ],
    new ChoosePublicFunding(),
);
